<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">내 PC 취약점 검사</h1>
      <p class="page-tit" aria-hidden="true">내 PC 취약점 검사</p>
    </div>

    <h2 class="section-title">점검 결과 정보</h2>

    <table class="form-table type-block--mobile">
      <caption>
        점검 결과 정보 표
      </caption>
      <colgroup>
        <col width="20%" />
        <col width="80%" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">점검 일시</th>
          <td>{{ convertDateFormatForJson(detailItem?.inspectStartDate) }}</td>
        </tr>
        <tr>
          <th scope="row">진행 상태</th>
          <td>{{ convertStatus(detailItem) }}</td>
        </tr>
        <tr>
          <th scope="row">취약점 발견 건수</th>
          <td>
            {{ detailItem?.inspectionResults?.length || 0 }} /
            {{ detailItem?.totalCount || 0 }}
            (발견 건수 / 검사 건수)
          </td>
        </tr>
        <tr>
          <th scope="row">발견된 취약점 심각도</th>
          <td>
            <div class="state__wrap">
              <span
                v-for="(count, severity) in severityCounts"
                :key="severity"
                :class="['state', severityClass(severity)]"
              >
                {{ severity || "-" }} {{ count }}건
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">SBOM 버전</th>
          <td>{{ detailItem?.vpmdVersion || "-" }}</td>
        </tr>
      </tbody>
    </table>

    <div class="section-pt">
      <h2 class="section-title">발견된 취약점 정보</h2>
      <table
        class="list-table type-block--mobile has-state"
        style="table-layout: inherit"
      >
        <caption>
          발견된 취약점 정보 테이블입니다
        </caption>
        <colgroup>
          <col width="23%" span="4" />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">제조사</th>
            <th scope="col">제품명</th>
            <th scope="col">KVE</th>
            <th scope="col">상세보기</th>
          </tr>
        </thead>
        <tbody
          v-if="
            detailItem.inspectionResults == null ||
            detailItem.inspectionResults.length == 0
          "
        >
          <tr>
            <td class="info-field" colspan="4">발견된 취약점 정보 없음...</td>
          </tr>
        </tbody>
        <tbody
          v-for="(item, index) in detailItem.inspectionResults"
          :key="index"
        >
          <tr>
            <td class="info-field">
              <span class="th--only-mobile">제조사</span> {{ item.makr || "-" }}
            </td>
            <td class="tit-field">{{ item.swNm || "-" }}</td>
            <td class="info-field">
              <span class="th--only-mobile">KVE</span> {{ item.kve || "-" }}
            </td>
            <td class="btn-open-field">
              <button
                type="button"
                @click="toggleDetail(item)"
                class="btn_open"
                :class="{ 'is-active': item.showDetail }"
                :aria-expanded="item.showDetail"
                :aria-controls="'detail-' + index"
                :aria-hidden="!item.showDetail"
              >
                <span class="svg_icon icon_next">상세보기 열기</span>
              </button>
            </td>
          </tr>
          <tr
            v-show="item?.showDetail"
            class="list-table__detail"
            :id="'detail-' + index"
            role="region"
            :aria-labelledby="'detail-label-' + index"
          >
            <td colspan="5">
              <ol class="detail-list">
                <li>
                  <p class="detail-list__tit">KVE/CVE</p>
                  <p class="detail-list__field">
                    {{ item.kve || "-"
                    }}<span v-if="item.cve">\{{ item.cve }}</span>
                  </p>
                </li>
                <li>
                  <p class="detail-list__tit" style="display: flex">
                    심각도
                    <Tooltip
                      v-if="severityTooltip(item)"
                      :item="severityTooltip(item)"
                    >
                      <i
                        class="svg_icon icon_time gray"
                        aria-hidden="true"
                        v-if="item?.severityHistory"
                      >
                      </i
                    ></Tooltip>
                  </p>

                  <p class="detail-list__field">
                    <span
                      class="state type-s"
                      :class="severityClass(item.severity)"
                      >{{ item.severity || "-" }}</span
                    >
                  </p>
                </li>
                <li>
                  <p class="detail-list__tit">취약점 설명</p>
                  <p class="detail-list__field">
                    {{ item.vulAttack || "-" }}
                  </p>
                </li>
                <li>
                  <p class="detail-list__tit">권장 조치 방안</p>
                  <!-- <p class="detail-list__field">
                    {{
                      Array.isArray(item.supportMethods) &&
                      item.supportMethods.length
                        ? item?.supportMethods
                            .map((m) => m.methodType)
                            .join(", ")
                        : "-"
                    }}
                  </p> -->
                  <p class="detail-list__field">
                    {{ item.actionGuide || "-" }}
                  </p>
                </li>
                <!-- <li>
                  <p class="detail-list__tit">참고 정보</p>
                  <p class="detail-list__field">참고 URL 등 정보 표현</p>
                </li> -->
                <li>
                  <p class="detail-list__tit">
                    파일 해시 정보
                    <Tooltip
                      v-if="hashTooltip(item)"
                      :item="hashTooltip(item)"
                      style="display: contents"
                    >
                      <i
                        class="svg_icon icon_time gray"
                        aria-hidden="true"
                        v-if="item?.severityHistory"
                      >
                      </i
                    ></Tooltip>
                  </p>
                  <div
                    v-for="(detect, index) in item?.detectedHashes || []"
                    :key="index"
                  >
                    <div
                      class="detail-list__field detail-list__grid"
                      v-for="field in detectedHashesField"
                      :key="field.key"
                    >
                      <p
                        class="detail-list__grid__tit"
                        :class="{ 'has-bg': index % 2 === 0 }"
                      >
                        {{ field.label }}
                      </p>
                      <p
                        class="detail-list__grid__field"
                        :class="{ 'has-bg': index % 2 === 0 }"
                      >
                        {{ detect[field.key] || "-" }}
                      </p>
                    </div>
                  </div>
                </li>
              </ol>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import dt from "@/component/DateTime.js";
import Tooltip from "@/component/Tooltip.vue";
import { computed, inject, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Tooltip,
  },
  setup() {
    const axios = inject("axios");
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const detailItem = ref({});
    const detectedHashesField = [
      { label: "파일 해시", key: "fileHash" },
      { label: "취약한 버전", key: "vulnVersion" },
      { label: "해결된 버전", key: "patchedVersion" },
    ];

    //methods 정의
    const toggleDetail = (item) => {
      item.showDetail = !item.showDetail;
    };

    const convertDateFormat = (date) => {
      return dt.dateTimeFormat(date);
    };
    const convertDateFormatForJson = (date) => {
      if (!date) return "-";
      return dt.dateTimeFormat(date?.$date);
    };
    const convertStatus = (data) => {
      switch (data.status) {
        case "Complete":
          return "완료";
        case "Error":
          return `오류(${data.description})`;
        case "Wait":
          return "대기";
        case "Processing":
          return "진행중";
        case "CanCel":
          return "취소";
        default:
          return "-";
      }
    };

    const fetchDetail = async (id) => {
      showLoading();
      axios
        .post("/scanner/pr/result/detail/get", { id })
        .then((res) => {
          if (res.data.resType === "RES_OK" && res.data.resList.length > 0) {
            detailItem.value = res.data.resList[0];
          } else {
            alert(
              "해당 점검의 상세 데이터가 없습니다.\n이전 페이지로 이동합니다."
            );
            router.go(-1);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const severityClass = (severity) => {
      switch (severity) {
        case "Low":
          return "state--blue";
        case "Medium":
          return "state--yellow";
        case "High":
          return "state--red";
        case "Critical":
          return "state--white";
        default:
          return "state--white";
      }
    };

    // 심각도 변경 이력 문자열 생성
    const severityTooltip = (item) => {
      if (!item?.severityHistory?.length) return "";
      const header = "변경 일시 || 변경전 || 변경후";
      const rows = item.severityHistory.map(
        (h) =>
          `${convertDateFormat(h.date.$date)} || ${h.old || "-"} || ${
            h.new || "-"
          }`
      );
      return [header, ...rows].join("\n--------------------------------\n");
    };

    //  해시 변경 이력 문자열 생성
    const hashTooltip = (item) => {
      if (!item?.hashHistory?.length) return "";
      const header = "변경 일시 || 변경전 || 변경후";
      const rows = item.hashHistory.map((h) => {
        const oldHashes = (h.old || []).join(", ");
        const newHashes = (h.new || []).join(", ");
        return `${convertDateFormat(h.date.$date)} || ${oldHashes || "-"} || ${
          newHashes || "-"
        }`;
      });
      return [header, ...rows].join(
        "\n----------------------------------------------------------------\n"
      );
    };

    // computed 정의
    const severityCounts = computed(() => {
      const list = detailItem.value.inspectionResults || [];
      return list.reduce((acc, item) => {
        const sev = item.severity;
        acc[sev] = (acc[sev] || 0) + 1;
        return acc;
      }, {});
    });

    // life cycle 정의
    onMounted(() => {
      if (!route.query.id) {
        router.push("/");
        return;
      }
      fetchDetail(route.query.id);
    });

    // html에서 사용될 데이터 정의
    return {
      toggleDetail,
      detailItem,
      convertStatus,
      severityClass,
      severityCounts,
      severityTooltip,
      hashTooltip,
      detectedHashesField,
      convertDateFormat,
      convertDateFormatForJson,
    };
  },
};
</script>


